import React, { useRef } from 'react';
import { Navigation, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { motion } from "framer-motion";
import 'swiper/css';
import 'swiper/css/navigation';

const Section5 = () => {


    const containerVariants = {
        hidden: {},
        visible: {
    
          transition: {
            staggerChildren: 0.1,
            delayChildren: 0.1,
            ease: "easeInOut"
          },
        },
        exit: {
    
          transition: { duration: 0, delay: 0 },
        },
      };
    
      const itemVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0, transition: { duration: 1 , ease: "easeInOut"} },
        exit: { opacity: 0, y: 20, transition: { duration: 0, delay: 0 } },
      };
    
    
    
    
      const photoVariants = {
        initial: { scale: 1.2, transition: { duration: 3, ease: "easeInOut" } },
        whileInView: { scale: 1, transition: { duration: 3, ease: "easeInOut" } },
        exit: { scale: 1.2, transition: { duration: 0, delay: 0 } },
      };
    


    const slides = [
        '/images/belgeler/1.png',
        '/images/belgeler/2.png',
        '/images/belgeler/3.png',
        '/images/belgeler/4.png',
        '/images/belgeler/5.png',
        '/images/belgeler/6.png',
        '/images/belgeler/7.png',
        '/images/belgeler/8.png',
        '/images/belgeler/9.png',
        '/images/belgeler/10.png',
        '/images/belgeler/11.png',
        '/images/belgeler/12.png',
        '/images/belgeler/13.png',
        '/images/belgeler/14.png',
        '/images/belgeler/15.png',
        '/images/belgeler/16.png',
        '/images/belgeler/17.png',
        '/images/belgeler/18.png',
        '/images/belgeler/19.png',
        '/images/belgeler/20.png',
        '/images/belgeler/21.png',
        '/images/belgeler/22.png',
    ];

    const swiperRef = useRef(null);

    return (
        <motion.div 
        initial="hidden"
        whileInView="visible"
        exit="exit"
        variants={containerVariants}
        
        className="grid grid-cols-10 py-14">
            <div className="col-span-1"></div>

            <div
                className="col-span-1 flex items-center cursor-pointer"
                onClick={() => swiperRef.current?.slidePrev()} 
            >
                <img src="/images/icons/left-hook.svg" alt="Left hook" />
            </div>

            <div className="col-span-6 bg-white">
                <Swiper
                    modules={[Navigation, Autoplay]}
                    onSwiper={(swiper) => (swiperRef.current = swiper)}
                    navigation={{
                        nextEl: '.right-hook',
                        prevEl: '.left-hook',
                    }}
                    autoplay={{
                        delay: 1000, 
                        disableOnInteraction: false, 
                    }}
                    spaceBetween={20}
                    slidesPerView={4}
                    breakpoints={{
                        320: { slidesPerView: 1 }, 
                        768: { slidesPerView: 2 }, 
                        1024: { slidesPerView: 4 }, 
                    }}
                >
                    {slides.map((slide, index) => (
                        <SwiperSlide key={index}>
                            <motion.img variants={itemVariants} src={slide} className="w-full" alt={`Slide ${index + 1}`} />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>

            <div
                className="col-span-1 flex items-center justify-end cursor-pointer"
                onClick={() => swiperRef.current?.slideNext()} // Custom next slide control
            >
                <img src="/images/icons/right-hook.svg" alt="Right hook" />
            </div>

            <div className="col-span-1"></div>
        </motion.div>
    );
};

export default Section5;
